/* eslint-disable */

/** unique or primary key constraints on table "argo.user_context" */
export enum ArgoUserContextConstraint {
  /** unique or primary key constraint on columns "user_context_id" */
  UserContextPkey = 'user_context_pkey',
  /** unique or primary key constraint on columns "context_id", "user_id" */
  UserContextUserIdContextIdKey = 'user_context_user_id_context_id_key'
}

/** select columns of table "argo.user_context" */
export enum ArgoUserContextSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "argo.user_context" */
export enum ArgoUserContextUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UserId = 'user_id'
}

